export function hasConfigurableLimit(module) {
  const t = module?.limit_type
  return Boolean(t && t !== 'none')
}

export function bytesToDisplay(bytes) {
  if (bytes == null || bytes === '') return { value: '', unit: 'GB' }
  const n = Number(bytes)
  if (!Number.isFinite(n)) return { value: '', unit: 'GB' }
  if (n >= 1073741824 && n % 1073741824 === 0) {
    return { value: String(n / 1073741824), unit: 'GB' }
  }
  if (n >= 1048576 && n % 1048576 === 0) {
    return { value: String(n / 1048576), unit: 'MB' }
  }
  if (n >= 1073741824) {
    return { value: String(+(n / 1073741824).toFixed(3)), unit: 'GB' }
  }
  return { value: String(+(n / 1048576).toFixed(3)), unit: 'MB' }
}

export function displayToBytes(value, unit) {
  const n = parseFloat(value)
  if (!Number.isFinite(n)) return null
  if (unit === 'MB') return Math.round(n * 1048576)
  return Math.round(n * 1073741824)
}

/** Build { [moduleId]: { value, limit_type, limit_unit } } for plan create/update */
export function buildModuleLimitsPayload(selectedModuleIds, modules, limitInputs) {
  const result = {}
  for (const id of selectedModuleIds) {
    const mod = modules.find((m) => m.id === id)
    if (!mod || !hasConfigurableLimit(mod)) continue
    const input = limitInputs[id] || {}
    if (input.value === '' || input.value == null) {
      result[id] = {
        value: null,
        limit_type: mod.limit_type,
        limit_unit: mod.limit_unit
      }
      continue
    }
    if (mod.limit_type === 'storage') {
      result[id] = {
        value: displayToBytes(input.value, input.storageUnit || 'GB'),
        limit_type: 'storage',
        limit_unit: mod.limit_unit || 'bytes'
      }
    } else {
      const n = parseInt(input.value, 10)
      result[id] = {
        value: Number.isFinite(n) ? n : null,
        limit_type: mod.limit_type,
        limit_unit: mod.limit_unit
      }
    }
  }
  return result
}

export function moduleLimitsToInputs(moduleLimits = {}, modules = []) {
  const inputs = {}
  Object.entries(moduleLimits || {}).forEach(([moduleId, limit]) => {
    const mod = modules.find((m) => m.id === moduleId)
    const limitType = limit?.limit_type || mod?.limit_type
    if (limitType === 'storage') {
      const display = bytesToDisplay(limit?.value)
      inputs[moduleId] = { value: display.value, storageUnit: display.unit }
    } else {
      inputs[moduleId] = {
        value: limit?.value == null ? '' : String(limit.value),
        storageUnit: 'GB'
      }
    }
  })
  return inputs
}

export function formatModuleLimitLabel(module) {
  if (!hasConfigurableLimit(module)) return null
  if (module.limit_type === 'storage') {
    return `Limit (${module.limit_unit || 'bytes'})`
  }
  return `Limit (${module.limit_unit || 'count'})`
}
